module.exports = __webpack_public_path__ + "assets/img/2402.683cfd56.png";